export default __webpack_public_path__ + "static/media/Serr Mayuri Jewellers.f715de68.jpg";